<script>
export default {
  name: 'MixinInput',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: [Object],
      default: () => ({}),
    },
    options: {
      type: Array,
      default: () => [],
    },
    event: {
      type: Object,
      default: () => ({}),
    },
    size: {
      type: String,
      default: 'small',
    },
  },
  computed: {
    placeholder() {
      let el = this.options.find((f) => f.value === this.value.key)
      return (
        (el && el.placeholder) ||
        `请输入${el?.label === '全部' ? '关键词' : el?.label || ''}`
      )
    },
  },
  data() {
    return {
      resizeObserver: null,
    }
  },
  created() {
    this.$set(this.value, 'key', this.value?.key || '')
    this.$set(this.value, 'value', this.value?.value || '')
  },
  methods: {
    generateSelect() {
      return (
        <el-select
          ref="mySelect"
          v-model={this.value.key}
          on={{ change: this.handleChange, clear: this.handleClear }}
          size={this.size}
        >
          {this.options.map((m) => {
            return <el-option props={{ ...m }}></el-option>
          })}
        </el-select>
      )
    },
    generateBtn() {
      return (
        <span class="search" onClick={this.handleBtnClick}>
          <i class="el-icon-search"></i>
        </span>
      )
    },
    handleInput(val) {
      //   this.$emit('input', this.value)
    },
    handleChange(val) {
      this.value.key = val
      this.value.value = ''
      //   this.$emit('input', this.value)
    },
    handleClear() {},
    handleBtnClick(event) {
      typeof this.event.keyup === 'function' && this.event.keyup(event, true)
    },
  },
  render(h) {
    return (
      <el-input
        v-model={this.value.value}
        nativeOn={{ input: this.handleInput, ...this.event }}
        placeholder={this.placeholder}
        size={this.size}
      >
        <template slot="prepend"> {this.generateSelect()}</template>
        <template slot="suffix">{this.generateBtn()}</template>
      </el-input>
    )
  },
}
</script>

<style lang="scss" scoped>
.el-input {
  ::v-deep {
    .el-input-group__prepend {
      min-width: 88px;
      width: 100px;
      max-width: 100px;
      box-sizing: border-box;
      .el-input__inner {
        color: #606266 !important;
      }
      .el-select {
        > .el-input {
          > input {
            border: none;
          }
        }
      }
    }
  }
  ::v-deep .el-input__suffix {
    right: 1px;
    .el-input__suffix-inner {
      height: 100%;
      display: inline-block;
      .search {
        cursor: pointer;
        margin-top: 1px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        height: calc(100% - 2px);
        display: inline-flex;
        align-items: center;
        padding: 0 8px;
        background: #f7f8fa;
        &:hover {
          background: #f0f2f5;
        }
        > i {
          font-size: 14px;
          color: #8c8c8c;
        }
      }
    }
  }
}
</style>
